export const SLOT_NO_LONGER_AVAILABLE = 'SLOT_NO_LONGER_AVAILABLE';

export const SLOT_NO_LONGER_AVAILABLE_MESSAGE =
  'Molimo odaberite drugi termin. U međuvremenu se ovaj termin rezervisao.';

type ReservationApiErrorData = {
  errorCode?: string;
  message?: string;
};

export const getReservationApiError = (error: unknown): ReservationApiErrorData => {
  const axiosError = error as {
    response?: { data?: ReservationApiErrorData & { data?: ReservationApiErrorData } };
  };
  const body = axiosError?.response?.data;
  if (!body) return {};
  if (body.errorCode || body.message) return body;
  return body.data ?? {};
};

export const isSlotNoLongerAvailableError = (error: unknown): boolean =>
  getReservationApiError(error).errorCode === SLOT_NO_LONGER_AVAILABLE;
